import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from "../c005-bookingform-common";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
import * as numeral from 'numeral';
let GrabID = require('GrabID');

export class memberPointsExchange {
	private partnerPointsExcForm:any   = $('#binfinitepoints-exchange-miles-form');
	$instance:any;
	private bookingformcommon = new bookingFormCommon();
	private initialBal:any;
	private minEnrichMilesTable:any;
	private sunwaypointExcList:any;
	private binfiniteExcList:any;
	private extRefList:any;
	private grabpointExcList:any;
	private grabIdClient:any;
	private bonusExcList:any;

	initSelectCard(): any {
    let defer = $.Deferred();
		let _self = this;
		let enrichMilesInput = _self.partnerPointsExcForm.find('#enrich-miles-field');
		let bInfiniteInput = _self.partnerPointsExcForm.find('#b-infinity-field');
		let sunway_enrichMilesInput = _self.partnerPointsExcForm.find('#sunwaypauls-enrich-miles-field');
		let sunway_Input = _self.partnerPointsExcForm.find('#sunwaypauls-field');
		let rangeInput = _self.partnerPointsExcForm.find('#rangeid');
		let grab_enrichMilesInput = _self.partnerPointsExcForm.find('#grab-enrich-points-field');
		let grabInputpoints = _self.partnerPointsExcForm.find('#grab-points-field');
		let bonusLinkEnrichPtsInput = _self.partnerPointsExcForm.find('#bonuslink-enrich-miles-field');
		let bonusLinkPtsInput = _self.partnerPointsExcForm.find('#bonuslink-field');
		var queryString, a, value1, value2;
		_self.bookingformcommon.preloader();
		if(_self.checkForUrlParams()) {
			$('#Grab').removeClass("hidden");
			$('#Grab').removeClass("inactive");
			$('#Grab').addClass("active");
			$('#Grab_tnc').removeClass("hidden");
            $('#Grab_tnc').removeClass("inactive");
            $('#Grab_tnc').addClass("active");
			$('#Grab_checkbox').removeClass("hidden");
            $('#Grab_checkbox').removeClass("inactive");
            $('#Grab_checkbox').addClass("active");
			value2 = "Grab";
		} else {
			queryString = location.search.substring(1);
			a = queryString.split("&");
			if(a[0]=="Grab=%2C"){
				value1 = 'Grab';
				value2 = 'Grab';
			}else{
				value1 = a[0];
				value2 = a[1];
			}
			$('#'+value2).removeClass("hidden");
			$('#'+value2).removeClass("inactive");
			$('#'+value2).addClass("active");
			$('#' + value2 + "_tnc").removeClass("hidden");
            $('#' + value2 + "_tnc").removeClass("inactive");
            $('#' + value2 + "_tnc").addClass("active");
			$('#' + value2 + "_checkbox").removeClass("hidden");
            $('#' + value2 + "_checkbox").removeClass("inactive");
            $('#' + value2 + "_checkbox").addClass("active");
		}
		$(".btn-member--cancel").click(function() {
			let partner_code  = $(".partner-crad-exchange.active input:hidden[class='partner_code_class']").val();
			if(partner_code == 'Grab') {
				let url = location.href;
				url = url.split('?')[0];
				window.location.href = url+'Grab&Grab';
			} else {
				location.reload();
			}
		});
		let bInfConvMilesTable:any;
		let awardcode:any;
		let cartId=value2;
		let partner=_self.partnerPointsExcForm.find(cartId);
		let max_exc_points:any;
		let pointExcList:any;
		let succCode:any;
		let stepValue:any;
		let cookieAccessToken = _self.getCookie("sapphire");
		var decodedToken = parseJwt(cookieAccessToken);
		let max_points = $(".partner-crad-exchange.active input:hidden[class='max_count_class']").val();
		let cap_count  = $(".partner-crad-exchange.active input:hidden[class='cap_period_class']").val();
		let partner_code  = $(".partner-crad-exchange.active input:hidden[class='partner_code_class']").val();
		
		var data = {
			'loyaltyToken':	decodedToken.extension_loyaltyToken,
			'enrichId': decodedToken.extension_flyerid,
			'partner_code': partner_code,
			'partnerId': cartId,
			'max_points':max_points,
			'cap_count':cap_count
		};
		_self.bookingformcommon.preloader();
		$.ajax({
			type: 'GET',
			url: '/bin/services/new/pointexchangecardDetailsLCP',
			data: data,
			success: function(data:any){
				//var json = JSON.parse(data);
				let json:any = null;
					if (typeof data === 'string') {
						json = JSON.parse(data);
					}	else {
						json = data;
					}
				_self.bookingformcommon.preloaderClose();
				_self.initialBal = json.currentBalance;
				max_exc_points=json.maxExchangePoints;
				pointExcList= json.pointsList;
				succCode=json.succCode;
				_self.sunwaypointExcList = json.sunwaypointsList;
				_self.binfiniteExcList = json.binfinitesList;
				_self.grabpointExcList = json.grabpointsList;
				_self.bonusExcList = json.bonusLinkList;

				if (succCode == "OK") {					
					$(".disply-partner-cards").removeClass("showclass");
					$(".disply-partner-cards").addClass("hideclass");
					$( "h2" ).hide();
					_self.extRefList=json.extLinkRefList;
					if(_self.extRefList!=null && _self.extRefList.length>0) {
						for(let i=0;i<_self.extRefList.length;i++){
							if(_self.extRefList[i].subType!=null && _self.extRefList[i].subType!="" && _self.extRefList[i].subType!=undefined){
							if(_self.extRefList[i].subType=="Binfinite"){
								$("#partner-card-number").val(_self.extRefList[i].identifier);
								$("#mob-partner-card-number").val(_self.extRefList[i].identifier);
							}
							if(_self.extRefList[i].subType=="Sunway Pals"){
								$("#sunwaypauls-partner-card-number").val(_self.extRefList[i].identifier);
								$("#mob-sunwaypauls-partner-card-number").val(_self.extRefList[i].identifier);
							}
							if((_self.extRefList[i].subType).toLowerCase()=="bonuslink"){
								$("#bonuslink-partner-card-number").val(_self.extRefList[i].identifier);
								$("#mob-bonuslink-partner-card-number").val(_self.extRefList[i].identifier);
							}
							}
						}
					}
					if(partner_code!=null && partner_code=="Binfinite") {
						$(".Binfinite").removeClass("hideclass");
						$(".Binfinite").addClass("showclass");
						$(".Sunwaypauls").removeClass("showclass");
						$(".Sunwaypauls").addClass("hideclass");
						//$("#rangeid").attr("max",max_exc_points);
						$(".points-exchange-form-display").removeClass("hideclass");//SHOW
						$(".points-exchange-form-display").addClass("showclass");//SHOW
						if(pointExcList.length>0) {
							for(let i=1;i<=pointExcList.length;i++){
								_self.minEnrichMilesTable = pointExcList[i-1].EnrichMinPoints;
								bInfConvMilesTable = pointExcList[i-1].BinfConvPoints;
								awardcode = pointExcList[i-1].AwardCode;
								stepValue=pointExcList[i-1].StepValue;
							}
						}
						let b_infinte_val = _self.partnerPointsExcForm.find( '#hidden_binifine_id');
						b_infinte_val.val(bInfConvMilesTable);
						//$("#rangeid").attr("step",stepValue);
						let mob_table = _self.partnerPointsExcForm.find("#mob-bInfConvMilesTable");
						let desktop_table = _self.partnerPointsExcForm.find('#bInfConvMilesTable');
						if(_self.binfiniteExcList.length>0){
							_self.minEnrichMilesTable=_self.binfiniteExcList[0].enrichMilesPoints;
							let lastIndex = parseInt(_self.binfiniteExcList.length)-1;
							$("#minmaxpoints").text(_self.binfiniteExcList[lastIndex].enrichMilesPoints);
							for(let j=1;j<=_self.binfiniteExcList.length;j++){
								desktop_table.append("<tr class='infiniterow'><td class='milesdada'>"+_self.binfiniteExcList[j-1].enrichMilesPoints+"<i class='fa fa-angle-right' aria-hidden='true'></i></td><td class='infinitydata'>"+_self.binfiniteExcList[j-1].binfinitePoints+"</td></tr>");
								mob_table.append("<tr class='mob-infiniterow'><td class='mob-milesdada'>"+_self.binfiniteExcList[j-1].enrichMilesPoints+"<i class='fa fa-angle-right' aria-hidden='true'></i></td><td class='mob-infinitydata'>"+_self.binfiniteExcList[j-1].binfinitePoints+"</td>tr>");  
							}
					   }
						if(parseInt(_self.initialBal)<parseInt(_self.minEnrichMilesTable)) {
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".rangeerrorBalCheck").removeClass("hideclass");
							$(".rangeerrorBalCheck").addClass("showclass");
							$(".btn-points-form--next").addClass("disablee");
						}
					}
					else if(partner_code!=null && partner_code=="Sunwaypals") {
						$(".Sunwaypauls").removeClass("hideclass");
						$(".Sunwaypauls").addClass("showclass");
						$(".Binfinite").removeClass("showclass");
						$(".Binfinite").addClass("hideclass");
						$(".points-exchange-form-display").removeClass("hideclass");//SHOW
						$(".points-exchange-form-display").addClass("showclass");//SHOW
						//$("#sunwaypauls-rangeid").attr("max",max_exc_points);
						if(pointExcList.length>0) {
							for(let i=1;i<=pointExcList.length;i++) {
								_self.minEnrichMilesTable = pointExcList[i-1].EnrichMinPoints;
								bInfConvMilesTable = pointExcList[i-1].BinfConvPoints;
								awardcode = pointExcList[i-1].AwardCode;
								stepValue=pointExcList[i-1].StepValue;
							}
						}
						let sunwaypauls_val = _self.partnerPointsExcForm.find( '#sunwaypauls-hidden_binifine_id');
						sunwaypauls_val.val(bInfConvMilesTable);
						let mob_table = _self.partnerPointsExcForm.find("#mob-sunwaypauls-ConvMilesTable");
						let desktop_table = _self.partnerPointsExcForm.find('#sunwaypauls-ConvMilesTable');
						if(_self.sunwaypointExcList.length>0){
							_self.minEnrichMilesTable=_self.sunwaypointExcList[0].enrichMilesPoints;
							let lastIndex = parseInt(_self.sunwaypointExcList.length)-1;
							$("#sunwaypauls-minmaxpoints").text(_self.sunwaypointExcList[lastIndex].enrichMilesPoints);
						for(let j=1;j<=_self.sunwaypointExcList.length;j++){
							desktop_table.append("<tr class='infiniterow'><td class='milesdada'>"+_self.sunwaypointExcList[j-1].enrichMilesPoints+"<i class='fa fa-angle-right' aria-hidden='true'></i></td><td class='infinitydata'>"+_self.sunwaypointExcList[j-1].sunwayPoints+"</td></tr>");
							mob_table.append("<tr class='mob-infiniterow'><td class='mob-milesdada'>"+_self.sunwaypointExcList[j-1].enrichMilesPoints+"<i class='fa fa-angle-right' aria-hidden='true'></i></td><td class='mob-infinitydata'>"+_self.sunwaypointExcList[j-1].sunwayPoints+"</td></tr>");  
						}
						}
						if(parseInt(_self.initialBal)<parseInt(_self.minEnrichMilesTable)) {
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".rangeerrorBalCheck").removeClass("hideclass");
							$(".rangeerrorBalCheck").addClass("showclass");
							$(".btn-points-form--next").addClass("disablee");
						}
					}
					else if(partner_code!=null && partner_code=="BonusLink") {
						$(".BonusLink").removeClass("hideclass");
						$(".BonusLink").addClass("showclass");
						$(".Sunwaypauls").removeClass("showclass");
						$(".Sunwaypauls").addClass("hideclass");
						$(".Binfinite").removeClass("showclass");
						$(".Binfinite").addClass("hideclass");
						$(".points-exchange-form-display").removeClass("hideclass");//SHOW
						$(".points-exchange-form-display").addClass("showclass");//SHOW
						//$("#sunwaypauls-rangeid").attr("max",max_exc_points);
						if(pointExcList.length>0) {
							for(let i=1;i<=pointExcList.length;i++) {
								_self.minEnrichMilesTable = pointExcList[i-1].EnrichMinPoints;
								bInfConvMilesTable = pointExcList[i-1].BinfConvPoints;
								awardcode = pointExcList[i-1].AwardCode;
								stepValue=pointExcList[i-1].StepValue;
							}
						}
						let bonusLink_val = _self.partnerPointsExcForm.find( '#bonuslink-hidden_binifine_value');
						bonusLink_val.val(bInfConvMilesTable);
						let mob_table = _self.partnerPointsExcForm.find("#mob-bonuslink-ConvMilesTable");
						let desktop_table = _self.partnerPointsExcForm.find('#bonuslink-ConvMilesTable');
						if(_self.bonusExcList.length>0){
							_self.minEnrichMilesTable=_self.bonusExcList[0].enrichMilesPoints;
							let lastIndex = parseInt(_self.bonusExcList.length)-1;
							$("#bonuslink-minmaxpoints").text(_self.bonusExcList[lastIndex].enrichMilesPoints);
						for(let j=1;j<=_self.bonusExcList.length;j++){
							desktop_table.append("<tr class='infiniterow'><td class='milesdada'>"+_self.bonusExcList[j-1].enrichMilesPoints+"<i class='fa fa-angle-right' aria-hidden='true'></i></td><td class='infinitydata'>"+_self.bonusExcList[j-1].bonuslinkPoints+"</td></tr>");
							mob_table.append("<tr class='mob-infiniterow'><td class='mob-milesdada'>"+_self.bonusExcList[j-1].enrichMilesPoints+"<i class='fa fa-angle-right' aria-hidden='true'></i></td><td class='mob-infinitydata'>"+_self.bonusExcList[j-1].bonuslinkPoints+"</td></tr>");  
						}
						}
						$("#bonuslink-rangeid").attr("step", stepValue);
						if(parseInt(_self.initialBal)<parseInt(_self.minEnrichMilesTable)) {
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".rangeerrorBalCheck").removeClass("hideclass");
							$(".rangeerrorBalCheck").addClass("showclass");
							$(".btn-points-form--next").addClass("disablee");
						}
					}
					 else if(partner_code == 'Grab') {
						let status = _self.checkForUrlParams();
						_self.initGrabAuthentication();
						if(!status) {
							_self.grabIdClient.makeAuthorizationRequest();
						} else {
							$(".points-exchange-form-display").removeClass("hideclass");//SHOW
							$(".points-exchange-form-display").addClass("showclass");//SHOW
							_self.processGrab(_self);
							let lastIndex = parseInt(_self.grabpointExcList.length)-1;
							let minEnrichMilesTable:any;
							let grabConvMilesTable:any;
							let stepValue:any;
							$("#grab-minmaxpoints").text(_self.grabpointExcList[lastIndex].enrichMilesPoints);
							$("#grab-minmaxpoints1").text(_self.grabpointExcList[0].enrichMilesPoints);
							$("#grab-rangeid").attr("max", max_exc_points);
							$(".grab-drag").removeClass("hideclass");
							$(".grab-div").addClass("showclass");
							$(".grab-section").removeClass("hideclass");
							$(".grab-section").addClass("showclass");
							for(let i=1;i<=pointExcList.length;i++) {
								minEnrichMilesTable = pointExcList[i-1].EnrichMinPoints;
								grabConvMilesTable = pointExcList[i-1].BinfConvPoints;
								stepValue=pointExcList[i-1].StepValue;
							}
							let grab_val = _self.partnerPointsExcForm.find( '#hidden_grab_id');
							grab_val.val(grabConvMilesTable);
							let grab_minEnrich_val = _self.partnerPointsExcForm.find( '#hidden_grab_minEnrichValue_id');
							minEnrichMilesTable = parseInt(_self.grabpointExcList[0].enrichMilesPoints);
							grabConvMilesTable = parseInt(_self.grabpointExcList[0].grabPoints);
							grab_minEnrich_val.val(minEnrichMilesTable);
							$('#grabConvMilesTable td').eq(0).html(minEnrichMilesTable);
							$('#grabConvMilesTable td').eq(2).html(grabConvMilesTable);
							let mob_table = _self.partnerPointsExcForm.find("#mob-grabConvMilesTable");
							let desktop_table = _self.partnerPointsExcForm.find('#grabConvMilesTable');
							for(let j=1;j<=_self.grabpointExcList.length;j++) {
								desktop_table.append("<tr><td class='mob-milesdada'>"+_self.grabpointExcList[j-1].enrichMilesPoints+"</td><td> > </td><td class='mob-infinitydata'>"+_self.grabpointExcList[j-1].grabPoints+"</td></tr>");
								mob_table.append("<tr><td class='mob-milesdada'>"+_self.grabpointExcList[j-1].enrichMilesPoints+"</td><td> > </td><td class='mob-infinitydata'>"+_self.grabpointExcList[j-1].grabPoints+"</td></tr>");  
							}
							$("#grab-rangeid").attr("step", stepValue);
							if (parseInt(_self.initialBal) < parseInt(minEnrichMilesTable)) {
								$(".error-validation").removeClass("hideclass");
								$(".error-validation").addClass("showclass");
								$(".rangeerrorBalCheck").removeClass("hideclass");
								$(".rangeerrorBalCheck").addClass("showclass");
								$(".btn-points-form--next").addClass("disablee");
							};
							_self.bookingformcommon.preloader();
						}
					}
				} else if(succCode == "MPE_ERROR") {
					$(".maxErrorMsg").removeClass("hideclass");
					$(".maxErrorMsg").addClass("showclass");
				}
				defer.resolve(json);			
			}, error: function(error: any) {
				_self.bookingformcommon.preloaderClose();
				defer.reject(error);
			}
		});
		$("#rangeid").change(function() {
			let rangepoints=this.value;
			let rangeval=parseInt(rangepoints);
		if(_self.binfiniteExcList!=null && _self.binfiniteExcList.length>0) {
			if(rangepoints=="4200"){
				rangeval=parseInt(_self.binfiniteExcList[0].enrichMilesPoints);
				enrichMilesInput.val(_self.binfiniteExcList[0].enrichMilesPoints);

			}else if(rangepoints=="8400"){
				rangeval=parseInt(_self.binfiniteExcList[1].enrichMilesPoints);
				enrichMilesInput.val(_self.binfiniteExcList[1].enrichMilesPoints);

			}else if(rangepoints=="12600"){
				rangeval=parseInt(_self.binfiniteExcList[2].enrichMilesPoints);
				enrichMilesInput.val(_self.binfiniteExcList[2].enrichMilesPoints);

			}else if(rangepoints==="16800"){
				rangeval=parseInt(_self.binfiniteExcList[3].enrichMilesPoints);
				enrichMilesInput.val(_self.binfiniteExcList[3].enrichMilesPoints);

			}else if(rangepoints==="21000"){
				rangeval=parseInt(_self.binfiniteExcList[4].enrichMilesPoints);
				enrichMilesInput.val(_self.binfiniteExcList[4].enrichMilesPoints);

			}
			for(let j=1;j<=_self.binfiniteExcList.length;j++){
				if(rangeval==parseInt(_self.binfiniteExcList[j-1].enrichMilesPoints)){
					bInfiniteInput.val(parseInt(_self.binfiniteExcList[j-1].binfinitePoints));
				}
			}
			if(rangeval<_self.binfiniteExcList[0].enrichMilesPoints){
				bInfiniteInput.val("");
				bInfiniteInput.val("");
			}
		}
			//if(_self.binfiniteExcList!=null && _self.binfiniteExcList.length>0) {
				
			//}
		});
		$("#grab-rangeid").change(function() {
			let rangepoints=this.value;
			let rangeval=parseInt(rangepoints);
			let enrichMilesDeduct: any;
			if(rangeval == 500) {
				grabInputpoints.val(parseInt(_self.grabpointExcList[0].grabPoints));
				grab_enrichMilesInput.val(parseInt(_self.grabpointExcList[0].enrichMilesPoints));
				enrichMilesDeduct= parseInt(_self.grabpointExcList[0].enrichMilesPoints);
			} else if(rangepoints == 1000) {
				grabInputpoints.val(parseInt(_self.grabpointExcList[1].grabPoints));
				grab_enrichMilesInput.val(parseInt(_self.grabpointExcList[1].enrichMilesPoints));
				enrichMilesDeduct= parseInt(_self.grabpointExcList[1].enrichMilesPoints);
			} else if(rangepoints == 1500) {
				grabInputpoints.val(parseInt(_self.grabpointExcList[2].grabPoints));
				grab_enrichMilesInput.val(parseInt(_self.grabpointExcList[2].enrichMilesPoints));
				enrichMilesDeduct= parseInt(_self.grabpointExcList[2].enrichMilesPoints);
			} else if(rangepoints == 2000) {
				grabInputpoints.val(parseInt(_self.grabpointExcList[3].grabPoints));
				grab_enrichMilesInput.val(parseInt(_self.grabpointExcList[3].enrichMilesPoints));
				enrichMilesDeduct= parseInt(_self.grabpointExcList[3].enrichMilesPoints);
			} else if(rangepoints == 2500) {
				grabInputpoints.val(parseInt(_self.grabpointExcList[4].grabPoints));
				grab_enrichMilesInput.val(parseInt(_self.grabpointExcList[4].enrichMilesPoints));
				enrichMilesDeduct= parseInt(_self.grabpointExcList[4].enrichMilesPoints);
			}

			let milesCountCookie = _self.getCookie("milesCount");
			if((parseInt(milesCountCookie)) < enrichMilesDeduct){
				if($(".grab-section .rangeerrorBalCheck").hasClass("hideclass"))
				{
					$(".grab-section .error-validation").removeClass("hideclass");
					$(".grab-section .error-validation").addClass("showclass");
					$(".grab-section .rangeerrorBalCheck").addClass("showclass");
					$(".grab-section .rangeerrorBalCheck").removeClass("hideclass");
					$(".btn-member--submit").addClass("disabled");
				}
			}else{
				if($(".grab-section .rangeerrorBalCheck").hasClass("showclass"))
				{
					$(".grab-section .error-validation").removeClass("showclass");
					$(".grab-section .error-validation").addClass("hideclass");
					$(".grab-section .rangeerrorBalCheck").addClass("hideclass");
					$(".grab-section .rangeerrorBalCheck").removeClass("showclass");
					$(".btn-member--submit").removeClass("disabled");
				}
			}
		});
		$("#sunwaypauls-rangeid").change(function() {
			let partner_code  = $(".partner-crad-exchange.active input:hidden[class='partner_code_class']").val();
			let rangepoints=this.value;
			let rangeval=parseInt(rangepoints);
		if(_self.sunwaypointExcList!=null && _self.sunwaypointExcList.length>0){
			if(rangepoints=="2200"){
				rangeval=parseInt(_self.sunwaypointExcList[0].enrichMilesPoints);
				enrichMilesInput.val(_self.sunwaypointExcList[0].enrichMilesPoints);
			}else if(rangepoints=="4400"){
				rangeval=parseInt(_self.sunwaypointExcList[1].enrichMilesPoints);
				enrichMilesInput.val(_self.sunwaypointExcList[0].enrichMilesPoints);
			}else if(rangepoints=="6600"){
				rangeval=parseInt(_self.sunwaypointExcList[2].enrichMilesPoints);
				enrichMilesInput.val(_self.sunwaypointExcList[0].enrichMilesPoints);
			}else if(rangepoints==="8800"){
				rangeval=parseInt(_self.sunwaypointExcList[3].enrichMilesPoints);
				enrichMilesInput.val(_self.sunwaypointExcList[0].enrichMilesPoints);
			}else if(rangepoints==="11000"){
				rangeval=parseInt(_self.sunwaypointExcList[4].enrichMilesPoints);
				enrichMilesInput.val(_self.sunwaypointExcList[0].enrichMilesPoints);
			}
			
			let sunway_rangepoints=this.value;
			let sunway_rangeval=parseInt(sunway_rangepoints);
	
			if(sunway_rangepoints=="2200"){
				sunway_rangeval=parseInt(_self.sunwaypointExcList[0].enrichMilesPoints);
				sunway_enrichMilesInput.val(sunway_rangeval);
			}else if(sunway_rangepoints=="4400"){
				sunway_rangeval=parseInt(_self.sunwaypointExcList[1].enrichMilesPoints);
				sunway_enrichMilesInput.val(sunway_rangeval);
			}else if(sunway_rangepoints=="6600"){
				sunway_rangeval=parseInt(_self.sunwaypointExcList[2].enrichMilesPoints);
				sunway_enrichMilesInput.val(sunway_rangeval);
			}else if(sunway_rangepoints==="8800"){
				sunway_rangeval=parseInt(_self.sunwaypointExcList[3].enrichMilesPoints);
				sunway_enrichMilesInput.val(sunway_rangeval);
			}else if(sunway_rangepoints==="11000"){
				sunway_rangeval=parseInt(_self.sunwaypointExcList[4].enrichMilesPoints);
				sunway_enrichMilesInput.val(sunway_rangeval);
			}
			for(let j=1;j<=_self.sunwaypointExcList.length;j++){
				
				if(sunway_rangeval==parseInt(_self.sunwaypointExcList[j-1].enrichMilesPoints)){
				
					sunway_Input.val(parseInt(_self.sunwaypointExcList[j-1].sunwayPoints));
				}
			}
		
			if(parseInt(sunway_rangepoints)<_self.sunwaypointExcList[0].enrichMilesPoints){
					sunway_Input.val("");
					sunway_enrichMilesInput.val("");
			}
		}
			//if(_self.sunwaypointExcList!=null && _self.sunwaypointExcList.length>0){
			
		//}
		});
		$("#bonuslink-rangeid").change(function() {
			
		if(_self.bonusExcList!=null && _self.bonusExcList.length>0){		
			let bonusLink_rangepoints=this.value;
			let bonusLink_rangeval=parseInt(bonusLink_rangepoints);
	
			if(bonusLink_rangepoints=="1200"){
				bonusLink_rangeval=parseInt(_self.bonusExcList[0].enrichMilesPoints);
				bonusLinkEnrichPtsInput.val(bonusLink_rangeval);
			}else if(bonusLink_rangepoints=="2400"){
				bonusLink_rangeval=parseInt(_self.bonusExcList[1].enrichMilesPoints);
				bonusLinkEnrichPtsInput.val(bonusLink_rangeval);
			}else if(bonusLink_rangepoints=="3600"){
				bonusLink_rangeval=parseInt(_self.bonusExcList[2].enrichMilesPoints);
				bonusLinkEnrichPtsInput.val(bonusLink_rangeval);
			}else if(bonusLink_rangepoints==="4800"){
				bonusLink_rangeval=parseInt(_self.bonusExcList[3].enrichMilesPoints);
				bonusLinkEnrichPtsInput.val(bonusLink_rangeval);
			}else if(bonusLink_rangepoints==="6000"){
				bonusLink_rangeval=parseInt(_self.bonusExcList[4].enrichMilesPoints);
				bonusLinkEnrichPtsInput.val(bonusLink_rangeval);
			}
			for(let j=1;j<=_self.bonusExcList.length;j++){
				
				if(bonusLink_rangeval==parseInt(_self.bonusExcList[j-1].enrichMilesPoints)){
				
					bonusLinkPtsInput.val(parseInt(_self.bonusExcList[j-1].bonuslinkPoints));
				}
			}
		
			if(parseInt(bonusLink_rangepoints)<_self.bonusExcList[0].enrichMilesPoints){
				bonusLinkPtsInput.val("");
					bonusLinkEnrichPtsInput.val("");
			}
		}
			//if(_self.sunwaypointExcList!=null && _self.sunwaypointExcList.length>0){
			
		//}
		});
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};
	}
	getCookie(name:string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal:any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}
	initSubmitNextForm(): any {
		let defer = $.Deferred();
		let _self = this;
		//Binfinite
		let enrichMilesConfirmPoints = _self.partnerPointsExcForm.find('#total-miles-deduct--confirm');
		let bInfiniteConfirmPoints = _self.partnerPointsExcForm.find('#total-binfinite-recieve--confirm');
		let cardConfirmNumber = _self.partnerPointsExcForm.find('#b-infinite-acct-number--confirm');
		//SunwayPals
		let sunway_enrichMilesConfPts = _self.partnerPointsExcForm.find('#sunway-total-miles-deduct--confirm');
		let sunway_bInfConfPts = _self.partnerPointsExcForm.find('#sunway-total-binfinite-recieve--confirm');
		let sunway_cardConfirmNumber = _self.partnerPointsExcForm.find('#sunway-acct-number--confirm');
		//BonusLink
		let bonuslink_enrichMilesConfPts = _self.partnerPointsExcForm.find('#bonuslink-total-miles-deduct--confirm');
		let bonuslink_bInfConfPts = _self.partnerPointsExcForm.find('#bonuslink-total-binfinite-recieve--confirm');
		let bonuslink_cardConfirmNumber = _self.partnerPointsExcForm.find('#bonus-link-acct-number--confirm');
		//Grab
		let enrichGrabConfirmPoints = _self.partnerPointsExcForm.find('#grab-total-enrich-points-deduct-confirm');
		let grabConfirmPoints = _self.partnerPointsExcForm.find('#grab-total--recieve--confirm');

		$(".btn-points-form--next").click(function() {
			let partner_code  = $(".partner-crad-exchange.active input:hidden[class='partner_code_class']").val();
			//Binfinite
			let enrichMilesInputPoints = _self.partnerPointsExcForm.find('#enrich-miles-field').val();
		  let bInfiniteInputPoints = _self.partnerPointsExcForm.find('#b-infinity-field').val();
			let cardInputNumber_deskT = _self.partnerPointsExcForm.find('#partner-card-number').val();
			let cardInputNumber_mob = _self.partnerPointsExcForm.find('#mob-partner-card-number').val();
			//Sunwaypals
			let sunwaypauls_enrichMilsInpPts = _self.partnerPointsExcForm.find('#sunwaypauls-enrich-miles-field').val();
		  let sunwaypaulsInpPts = _self.partnerPointsExcForm.find('#sunwaypauls-field').val();
			let sunwaypauls_InpNum_deskT = _self.partnerPointsExcForm.find('#sunwaypauls-partner-card-number').val();
			let sunwaypauls_InpNum_mob = _self.partnerPointsExcForm.find('#mob-sunwaypauls-partner-card-number').val();
			//BonusLink
			let bonuslink_enrichMilsInpPts = _self.partnerPointsExcForm.find('#bonuslink-enrich-miles-field').val();
		  	let bonuslinkInpPts = _self.partnerPointsExcForm.find('#bonuslink-field').val();
			let bonuslink_InpNum_deskT = _self.partnerPointsExcForm.find('#bonuslink-partner-card-number').val();
			let bonuslink_InpNum_mob = _self.partnerPointsExcForm.find('#mob-bonuslink-partner-card-number').val();


			let enrichInptsPts = _self.partnerPointsExcForm.find('#grab-enrich-points-field').val();
		  let grabCalPts = _self.partnerPointsExcForm.find('#grab-points-field').val();
			let partnerUuid = _self.partnerPointsExcForm.find('#hidden_grab_partner_uuid').val();

			let cardInputNumber:any;
			let enrichMiles:any;
			let inputPoints:any;
			let cardNumberwithSpace:any;
			if(partner_code!=null && partner_code=="Sunwaypals") {
				if(sunwaypauls_InpNum_mob!="") {
					cardInputNumber=sunwaypauls_InpNum_mob;
				} else {
					cardInputNumber=sunwaypauls_InpNum_deskT;
				}
				enrichMiles=sunwaypauls_enrichMilsInpPts;
				inputPoints=sunwaypaulsInpPts;
			}else if(partner_code!=null && partner_code=="BonusLink") {
				if(bonuslink_InpNum_mob!="") {
					cardInputNumber=bonuslink_InpNum_mob;
				} else {
					cardInputNumber=bonuslink_InpNum_deskT;
				}
				enrichMiles=bonuslink_enrichMilsInpPts;
				inputPoints=bonuslinkInpPts;
			} else {
				if(cardInputNumber_mob!="") {	
					cardInputNumber=cardInputNumber_mob;
				} else {
					cardInputNumber=cardInputNumber_deskT;
				}
				enrichMiles=enrichMilesInputPoints;
				inputPoints=bInfiniteInputPoints;
			}
			if(partner_code != 'Grab') {
				cardNumberwithSpace=cardInputNumber;
				//alert("cardInputNumber>>"+cardNumberwithSpace);
				cardInputNumber=cardInputNumber.replace(/ /g,'');
			}
			 if((partner_code != 'Grab') && (enrichMiles=="" || inputPoints=="" || cardInputNumber=="" || !($('#points-exc--miles-terms-and-conditions').prop('checked')))) {
			 	if(!($('#points-exc--miles-terms-and-conditions').prop('checked'))) {
			 		if(cardInputNumber=="") {
						$(".error-validation").removeClass("hideclass");
						$(".error-validation").addClass("showclass");
						$(".accounterror").removeClass("hideclass");
						$(".accounterror").addClass("showclass");
			 		} else {
						$(".accounterror").removeClass("showclass");
						$(".accounterror").addClass("hideclass");
						$(".error-validation").removeClass("showclass");
						$(".error-validation").addClass("hideclass");
			 		}
			 		if(enrichMiles=="" || inputPoints=="") {
			 			$(".error-validation").removeClass("hideclass");
                 	    $(".error-validation").addClass("showclass");
			 			$(".rangeerror").removeClass("hideclass");
			 			$(".rangeerror").addClass("showclass");
			 		} else {
			 			$(".rangeerror").removeClass("showclass");
			 			$(".rangeerror").addClass("hideclass");
			 			$(".error-validation").removeClass("showclass");
            $(".error-validation").addClass("hideclass");
			 		}
			 		$(".radioErrMsg").removeClass("hideclass");
			 		$(".radioErrMsg").addClass("showclass");
			 		$(".error-validation").removeClass("hideclass");
          $(".error-validation").addClass("showclass");
			 	} else {
			 		$(".radioErrMsg").removeClass("showclass");
			 		$(".radioErrMsg").addClass("hideclass");
			 		$(".error-validation").removeClass("showclass");
          $(".error-validation").addClass("hideclass");
			 		if(cardInputNumber=="") {
						if(enrichMiles==""|| inputPoints=="") {
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".rangeerror").removeClass("hideclass");
							$(".rangeerror").addClass("showclass");
						} else {
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
						}
						$(".error-validation").removeClass("hideclass");
						$(".error-validation").addClass("showclass");
						$(".accounterror").removeClass("hideclass");
						$(".accounterror").addClass("showclass");
			 		} else {
						$(".accounterror").removeClass("showclass");
						$(".accounterror").addClass("hideclass");
						$(".error-validation").removeClass("showclass");
						$(".error-validation").addClass("hideclass");
						if(enrichMiles==""|| inputPoints=="") {
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".rangeerror").removeClass("hideclass");
							$(".rangeerror").addClass("showclass");
						} else {
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
						}
			 		}
				}
			 } else if(partner_code !== 'Grab' && cardInputNumber.length!=16){
			 	if(cardInputNumber.length==16){
			 		$(".error-validation").removeClass("showclass");
			 		$(".error-validation").addClass("hideclass");
			 		$(".cardStatusError").removeClass("showclass");
			 		$(".cardStatusError").addClass("hideclass");
			 	} else {
			 		$(".error-validation").removeClass("hideclass");
			 		$(".error-validation").addClass("showclass");
			 		$(".cardStatusError").removeClass("hideclass");
			 		$(".cardStatusError").addClass("showclass");
			 	}
			 }
			else if((parseInt(_self.initialBal)<parseInt(_self.minEnrichMilesTable)) ||
			(parseInt(_self.initialBal)<parseInt(enrichMiles)))
			{
				$(".error-validation").removeClass("hideclass");
      			$(".error-validation").addClass("showclass");
				$(".rangeerrorBalCheck").removeClass("hideclass");
				$(".rangeerrorBalCheck").addClass("showclass");
			}
			 else if(partner_code == 'Grab') {
				$(".error-validation").removeClass("showclass");
				$(".error-validation").addClass("hideclass");
				$(".rangeerrorBalCheck").removeClass("showclass");
				$(".rangeerrorBalCheck").addClass("hideclass");
								$(".Binfinite-confirm").removeClass("showclass");
								$(".Binfinite-confirm").addClass("hideclass");
								$(".Sunwaypauls-confirm").removeClass("showclass");
								$(".Sunwaypauls-confirm").addClass("hideclass");
								$(".Grab-confirm").removeClass("hideclass");//show
								$(".Grab-confirm").addClass("showclass");//show
							//$("#termscondiText").removeClass("radioErrMsg");
							$(".radioErrMsg").removeClass("showclass");
                	        $(".radioErrMsg").addClass("hideclass");
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".accounterror").removeClass("showclass");
							$(".accounterror").addClass("hideclass");
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".rangeerrorBalCheck").removeClass("showclass");
							$(".rangeerrorBalCheck").addClass("hideclass");
							$(".disply-partner-cards").removeClass("showclass");
							$(".disply-partner-cards").addClass("hideclass");
							$(".points-exchange-form-display").removeClass("showclass");
							 $(".points-exchange-form-display").addClass("hideclass");
							$( "h2" ).hide();
							$(".points-exchange-form-confirm").removeClass("hideclass");//SHOW
							$(".points-exchange-form-confirm").addClass("showclass");//SHOW
							$(".confirm--button--form--field").removeClass("hideclass");//SHOW
							$(".confirm--button--form--field").addClass("showclass");//SHOW
							$(".confirm--mail--security--check").removeClass("showclass");
							$(".confirm--mail--security--check").addClass("hideclass");
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("showclass");
							$(".points-exchange-form-failure--div").addClass("hideclass");
							$(".cardStatusError").removeClass("showclass");
							$(".cardStatusError").addClass("hideclass");
							//alert("after succ"+cardNumberwithSpace);
							enrichMilesConfirmPoints.val(enrichMilesInputPoints);
							bInfiniteConfirmPoints.val(bInfiniteInputPoints);
							cardConfirmNumber.val(cardNumberwithSpace);	

							sunway_enrichMilesConfPts.val(sunwaypauls_enrichMilsInpPts);
							sunway_bInfConfPts.val(sunwaypaulsInpPts);
							sunway_cardConfirmNumber.val(cardNumberwithSpace);

							bonuslink_enrichMilesConfPts.val(bonuslink_enrichMilsInpPts);
							bonuslink_bInfConfPts.val(bonuslinkInpPts);
							bonuslink_cardConfirmNumber.val(cardNumberwithSpace);

							enrichGrabConfirmPoints.val(enrichInptsPts);
							grabConfirmPoints.val(grabCalPts);
			} else {
				$(".error-validation").removeClass("showclass");
				$(".error-validation").addClass("hideclass");
				$(".rangeerrorBalCheck").removeClass("showclass");
				$(".rangeerrorBalCheck").addClass("hideclass");
				let cardStatus:any;
				var data = {
					'cardNumber':	cardInputNumber,
					'partner_code':partner_code
				};
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'GET',
					url: '/bin/services/new/getBinfinitecardstatusLcp',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
							if (typeof data === 'string') {
								json = JSON.parse(data);
							}	else {
								json = data;
							}
						_self.bookingformcommon.preloaderClose();
						cardStatus=json.status;
						
						if (cardStatus == "Active") {
							if(partner_code!=null && partner_code=="Binfinite"){
								$(".Binfinite-confirm").removeClass("hideclass");
								$(".Binfinite-confirm").addClass("showclass");
								$(".Sunwaypauls-confirm").removeClass("showclass");
								$(".Sunwaypauls-confirm").addClass("hideclass");
								$(".Bonuslink-confirm").removeClass("showclass");
								$(".Bonuslink-confirm").addClass("hideclass");
							}else if(partner_code!=null && partner_code=="Sunwaypals"){
								$(".Sunwaypauls-confirm").removeClass("hideclass");
								$(".Sunwaypauls-confirm").addClass("showclass");
								$(".Binfinite-confirm").removeClass("showclass");
								$(".Binfinite-confirm").addClass("hideclass");
								$(".Bonuslink-confirm").removeClass("showclass");
								$(".Bonuslink-confirm").addClass("hideclass");
							}else if(partner_code!=null && partner_code=="BonusLink"){
								$(".Bonuslink-confirm").removeClass("hideclass");
								$(".Bonuslink-confirm").addClass("showclass");
								$(".Binfinite-confirm").removeClass("showclass");
								$(".Binfinite-confirm").addClass("hideclass");
								$(".Sunwaypauls-confirm").removeClass("showclass");
								$(".Sunwaypauls-confirm").addClass("hideclass");
							}
							//$("#termscondiText").removeClass("radioErrMsg");
							$(".radioErrMsg").removeClass("showclass");
                	        $(".radioErrMsg").addClass("hideclass");
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".accounterror").removeClass("showclass");
							$(".accounterror").addClass("hideclass");
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".rangeerrorBalCheck").removeClass("showclass");
							$(".rangeerrorBalCheck").addClass("hideclass");
							$(".disply-partner-cards").removeClass("showclass");
							$(".disply-partner-cards").addClass("hideclass");
							$(".points-exchange-form-display").removeClass("showclass");
							 $(".points-exchange-form-display").addClass("hideclass");
							$( "h2" ).hide();
							$(".points-exchange-form-confirm").removeClass("hideclass");//SHOW
							$(".points-exchange-form-confirm").addClass("showclass");//SHOW
							$(".confirm--button--form--field").removeClass("hideclass");//SHOW
							$(".confirm--button--form--field").addClass("showclass");//SHOW
							$(".confirm--mail--security--check").removeClass("showclass");
							$(".confirm--mail--security--check").addClass("hideclass");
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("showclass");
							$(".points-exchange-form-failure--div").addClass("hideclass");
							$(".cardStatusError").removeClass("showclass");
							$(".cardStatusError").addClass("hideclass");
							//alert("after succ"+cardNumberwithSpace);
							//Binfinite
							enrichMilesConfirmPoints.val(enrichMilesInputPoints);
							bInfiniteConfirmPoints.val(bInfiniteInputPoints);
							cardConfirmNumber.val(cardNumberwithSpace);	
							//Sunwaypals
							sunway_enrichMilesConfPts.val(sunwaypauls_enrichMilsInpPts);
							sunway_bInfConfPts.val(sunwaypaulsInpPts);
							sunway_cardConfirmNumber.val(cardNumberwithSpace);
							//BonusLink
							bonuslink_enrichMilesConfPts.val(bonuslink_enrichMilsInpPts);
							bonuslink_bInfConfPts.val(bonuslinkInpPts);
							bonuslink_cardConfirmNumber.val(cardNumberwithSpace);

												
						}
						else
						{
							$(".error-validation").removeClass("hideclass");
                   			$(".error-validation").addClass("showclass");
							$(".accounterror").removeClass("showclass");
							$(".accounterror").addClass("hideclass");
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".rangeerrorBalCheck").removeClass("showclass");
							$(".rangeerrorBalCheck").addClass("hideclass");
							$(".cardStatusError").removeClass("hideclass");
							$(".cardStatusError").addClass("showclass");
						}
						defer.resolve(json);			
					}, error: function(error: any) {
						
						_self.bookingformcommon.preloaderClose();
						defer.reject(error);
					}
				});
			}
		});

		$("#partner-card-number").keypress(function (e:any) {
			$("#mob-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#partner-card-number').val(foo);
			return true;
			}
		});
		$("#partner-card-number").keyup(function (e:any) {
			$("#mob-partner-card-number").val('');
			let foo = $('#partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#partner-card-number').val(foo);
			return true;
		});
		$("#mob-partner-card-number").keypress(function (e:any) {
			$("#partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#mob-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-partner-card-number').val(foo);
			return true;
			}
		});
		$("#mob-partner-card-number").keyup(function (e:any) {
			$("#partner-card-number").val('');
			let foo = $('#mob-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-partner-card-number').val(foo);
			return true;
		});
		$("#sunwaypauls-partner-card-number").keypress(function (e:any) {
			$("#mob-sunwaypauls-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#sunwaypauls-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#sunwaypauls-partner-card-number').val(foo);
			}
		});
		$("#sunwaypauls-partner-card-number").keyup(function (e:any) {
			$("#mob-sunwaypauls-partner-card-number").val('');
			let foo = $('#sunwaypauls-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#sunwaypauls-partner-card-number').val(foo);
		});
		$("#mob-sunwaypauls-partner-card-number").keypress(function (e:any) {
			$("#sunwaypauls-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#mob-sunwaypauls-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-sunwaypauls-partner-card-number').val(foo);
			}
		});
		$("#mob-sunwaypauls-partner-card-number").keyup(function (e:any) {
			$("#sunwaypauls-partner-card-number").val('');
			let foo = $('#mob-sunwaypauls-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-sunwaypauls-partner-card-number').val(foo);
		});
		// Bonus Link bonuslink-partner-card-number
		$("#bonuslink-partner-card-number").keypress(function (e:any) {
			$("#mob-bonuslink-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#bonuslink-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#bonuslink-partner-card-number').val(foo);
			}
		});
		$("#bonuslink-partner-card-number").keyup(function (e:any) {
			$("#mob-bonuslink-partner-card-number").val('');
			let foo = $('#bonuslink-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#bonuslink-partner-card-number').val(foo);
		});
		$("#mob-bonuslink-partner-card-number").keypress(function (e:any) {
			$("#bonuslink-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#mob-bonuslink-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-bonuslink-partner-card-number').val(foo);
			}
		});
		$("#mob-bonuslink-partner-card-number").keyup(function (e:any) {
			$("#bonuslink-partner-card-number").val('');
			let foo = $('#mob-bonuslink-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-bonuslink-partner-card-number').val(foo);
		});


		$('input[type="radio"]').click(function() {
			if($(this).attr('id') == 'points-exc--miles-terms-and-conditions') {
				//$("#termscondiText").removeClass("radioErrMsg");
				$(".radioErrMsg").removeClass("showclass");
				$(".radioErrMsg").addClass("hideclass");
				$(".error-validation").removeClass("showclass");
                $(".error-validation").addClass("hideclass");
			}
			else {
				//$("#termscondiText").addClass("radioErrMsg");
				$(".radioErrMsg").removeClass("hideclass");
				$(".radioErrMsg").addClass("showclass");
				$(".error-validation").removeClass("hideclass");
                $(".error-validation").addClass("showclass");
			}
		});
		
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};
	}
	initSubmitConfirmForm(): any {
		let defer = $.Deferred();
		let _self = this;
		let enrichMilesConfirmPoints = _self.partnerPointsExcForm.find('#total-miles-deduct--confirm');
		let bInfiniteConfirmPoints = _self.partnerPointsExcForm.find('#total-binfinite-recieve--confirm');
		let cardConfirmNumber = _self.partnerPointsExcForm.find('#b-infinite-acct-number--confirm');

		let sunway_enrichMilesConfPts = _self.partnerPointsExcForm.find('#sunway-total-miles-deduct--confirm');
		let sunway_bInfConfPts = _self.partnerPointsExcForm.find('#sunway-total-binfinite-recieve--confirm');
		let sunway_cardConfirmNumber = _self.partnerPointsExcForm.find('#sunway-acct-number--confirm');
		$(".btn-points--confirm").click(function() {
			let partner_code  = $(".partner-crad-exchange.active input:hidden[class='partner_code_class']").val();

			let enrichMilesInputPoints = _self.partnerPointsExcForm.find('#enrich-miles-field').val();
		    let bInfiniteInputPoints = _self.partnerPointsExcForm.find('#b-infinity-field').val();
			let cardInputNumber_deskT = _self.partnerPointsExcForm.find('#partner-card-number').val();
			let cardInputNumber_mob = _self.partnerPointsExcForm.find('#mob-partner-card-number').val();

			let sunwaypauls_enrichMilsInpPts = _self.partnerPointsExcForm.find('#sunwaypauls-enrich-miles-field').val();
		    let sunwaypaulsInpPts = _self.partnerPointsExcForm.find('#sunwaypauls-field').val();
			let sunwaypauls_InpNum_deskT = _self.partnerPointsExcForm.find('#sunwaypauls-partner-card-number').val();
			let sunwaypauls_InpNum_mob = _self.partnerPointsExcForm.find('#mob-sunwaypauls-partner-card-number').val();

			//BonusLink
			let bonuslink_enrichMilsInpPts = _self.partnerPointsExcForm.find('#bonuslink-enrich-miles-field').val();
		  	let bonuslinkInpPts = _self.partnerPointsExcForm.find('#bonuslink-field').val();
			let bonuslink_InpNum_deskT = _self.partnerPointsExcForm.find('#bonuslink-partner-card-number').val();
			let bonuslink_InpNum_mob = _self.partnerPointsExcForm.find('#mob-bonuslink-partner-card-number').val();

			let enrichInptsPts = _self.partnerPointsExcForm.find('#grab-enrich-points-field').val();
		  	let grabCalPts = _self.partnerPointsExcForm.find('#grab-points-field').val();

			let cardInputNumber:any;
			let enrichMiles:any;
			let inputPoints:any;
			let cardNumberwithSpace:any;

			if(partner_code!=null && partner_code=="Sunwaypals"){
				if(sunwaypauls_InpNum_mob!="")
				{
					cardInputNumber=sunwaypauls_InpNum_mob;
				}else 
				{
					cardInputNumber=sunwaypauls_InpNum_deskT;
				}
				enrichMiles=sunwaypauls_enrichMilsInpPts;
				inputPoints=sunwaypaulsInpPts;
			}else if(partner_code!=null && partner_code=="Binfinite"){
				if(cardInputNumber_mob!="")
				{	
					cardInputNumber=cardInputNumber_mob;
				}else 
				{
					cardInputNumber=cardInputNumber_deskT;
				}
				enrichMiles=enrichMilesInputPoints;
				inputPoints=bInfiniteInputPoints;
			}else if(partner_code!=null && partner_code=="BonusLink"){
				if(bonuslink_InpNum_mob!="")
				{	
					cardInputNumber=bonuslink_InpNum_mob;
				}else 
				{
					cardInputNumber=bonuslink_InpNum_deskT;
				}
				enrichMiles=bonuslink_enrichMilsInpPts;
				inputPoints=bonuslinkInpPts;
			}else if(partner_code!=null && partner_code=="Grab"){
				enrichMiles=enrichInptsPts;
				inputPoints=grabCalPts;
				cardInputNumber="0000"
			}
			cardNumberwithSpace=cardInputNumber;
			//alert("cardNumberwithSpace>>"+cardNumberwithSpace);
			cardInputNumber=cardInputNumber.replace(/ /g,'');

			$(".error-validation").removeClass("showclass");
			$(".error-validation").addClass("hideclass");
			$(".accounterror").removeClass("showclass");
			$(".accounterror").addClass("hideclass");
			$(".rangeerror").removeClass("showclass");
			$(".rangeerror").addClass("hideclass");
			$(".rangeerrorBalCheck").removeClass("showclass");
			$(".rangeerrorBalCheck").addClass("hideclass");
			$(".cardStatusError").removeClass("showclass");
			$(".cardStatusError").addClass("hideclass");
			
			if(enrichMiles=="" || cardInputNumber=="" || inputPoints=="")
			{
				$(".error-validation").removeClass("hideclass");
				$(".error-validation").addClass("showclass");
			}else{
				
				let cookieAccessToken = _self.getCookie("sapphire");
				var decodedToken = parseJwt(cookieAccessToken);
				let cap_count  = $(".partner-crad-exchange.active input:hidden[class='cap_period_class']").val();
				let partner_code  = $(".partner-crad-exchange.active input:hidden[class='partner_code_class']").val();
				let succCode:any;
				var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'partner_code': partner_code,
					'action':'generateOTP',
					'channel':'LCP'
				};
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/binfinitevalidateCartLCP',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
							if (typeof data === 'string') {
								json = JSON.parse(data);
							}	else {
								json = data;
							}
						_self.bookingformcommon.preloaderClose();
						succCode=json.succCode;
						
						if (succCode == "OK") {				
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".mailOTPError").removeClass("showclass");
							$(".mailOTPError").addClass("hideclass");
							enrichMilesConfirmPoints.val(enrichMilesInputPoints);
							bInfiniteConfirmPoints.val(bInfiniteInputPoints);
							cardConfirmNumber.val(cardNumberwithSpace);
							$(".disply-partner-cards").removeClass("showclass");
							$(".disply-partner-cards").addClass("hideclass");
							// $(".points-exchange-form-display").removeClass("showclass");
							// $(".points-exchange-form-display").addClass("hideclass");
							$( "h2" ).hide();
							$(".points-exchange-form-confirm").removeClass("hideclass");//SHOW
							$(".points-exchange-form-confirm").addClass("showclass");//SHOW
							$(".confirm--button--form--field").removeClass("showclass");
							$(".confirm--button--form--field").addClass("hideclass");
							$(".confirm--mail--security--check").removeClass("hideclass");//SHOW
							$(".confirm--mail--security--check").addClass("showclass");//SHOW
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("showclass");
							$(".points-exchange-form-failure--div").addClass("hideclass");
						}
						else
						{
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".mailOTPError").removeClass("hideclass");
							$(".mailOTPError").addClass("showclass");
						}
						defer.resolve(json);			
					}, error: function(error: any) {
						
						_self.bookingformcommon.preloaderClose();
						defer.reject(error);
					}
				});
			}
		});
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};
	}
	initSubmitSuucssForm(): any {
		let defer = $.Deferred();
		let _self = this;
		$(".btn-points--check--confirm--submit").click(function() {

			let securitycodecheck = _self.partnerPointsExcForm.find('#security-code--check').val();
			$(".error-validation").removeClass("showclass");
			$(".error-validation").addClass("hideclass");
			$(".accounterror").removeClass("showclass");
			$(".accounterror").addClass("hideclass");
			$(".rangeerror").removeClass("showclass");
			$(".rangeerror").addClass("hideclass");
			
			if(securitycodecheck=="")
			{
				$(".error-validation").removeClass("hideclass");
				$(".error-validation").addClass("showclass");
				$(".securityCodeerror").removeClass("hideclass");
				$(".securityCodeerror").addClass("showclass");
			}else{
				$(".btn-points--check--confirm--submit").addClass("disablee");
				let cookieAccessToken = _self.getCookie("sapphire");
				var decodedToken = parseJwt(cookieAccessToken);
				let cap_count  = $(".partner-crad-exchange.active input:hidden[class='cap_period_class']").val();
				let partner_code  = $(".partner-crad-exchange.active input:hidden[class='partner_code_class']").val();
				let validateCode = _self.partnerPointsExcForm.find('#security-code--check').val();
				let succCode:any;
				let partner_id  = $(".partner-crad-exchange.active a").attr('id');
				let max_points = $(".partner-crad-exchange.active input:hidden[class='max_count_class']").val();
				
				//let enrichMilesPoints = _self.partnerPointsExcForm.find('#enrich-miles-field').val();
				//let bInfinitePoints = _self.partnerPointsExcForm.find('#b-infinity-field').val();
				//let cardConfirmNumber = _self.partnerPointsExcForm.find('#b-infinite-acct-number--confirm').val();
				let enrichMilesInputPoints = _self.partnerPointsExcForm.find('#enrich-miles-field').val();
		    	let bInfiniteInputPoints = _self.partnerPointsExcForm.find('#b-infinity-field').val();
				let bInfcardConfirmNumber = _self.partnerPointsExcForm.find('#b-infinite-acct-number--confirm').val();

				let sunwaypauls_enrichMilsInpPts = _self.partnerPointsExcForm.find('#sunwaypauls-enrich-miles-field').val();
		   	 	let sunwaypaulsInpPts = _self.partnerPointsExcForm.find('#sunwaypauls-field').val();
				let sunway_cardConfNum= _self.partnerPointsExcForm.find('#sunway-acct-number--confirm').val();

				let bonuslink_enrichMilsInpPts = _self.partnerPointsExcForm.find('#bonuslink-enrich-miles-field').val();
		  		let bonuslinkInpPts = _self.partnerPointsExcForm.find('#bonuslink-field').val();
				let bonuslink_cardConfNum = _self.partnerPointsExcForm.find('#bonus-link-acct-number--confirm').val();

				let cardInputNumber:any;
				let enrichMiles:any;
				let inputPoints:any;
				
				if(partner_code!=null && partner_code=="Sunwaypals"){
					cardInputNumber=sunway_cardConfNum;
					enrichMiles=sunwaypauls_enrichMilsInpPts;
					inputPoints=sunwaypaulsInpPts;
				}else if(partner_code!=null && partner_code=="BonusLink"){
					cardInputNumber=bonuslink_cardConfNum;
					enrichMiles=bonuslink_enrichMilsInpPts;
					inputPoints=bonuslinkInpPts;
				}else{
					cardInputNumber=bInfcardConfirmNumber;
					enrichMiles=enrichMilesInputPoints;
					inputPoints=bInfiniteInputPoints;
				}
				cardInputNumber=cardInputNumber.replace(/ /g,'');
				if(partner_code!=null && partner_code=="Grab"){
					let enrichInptsPts = _self.partnerPointsExcForm.find('#grab-enrich-points-field').val();
		  			let grabCalPts = _self.partnerPointsExcForm.find('#grab-points-field').val();
					let partnerUuid = _self.partnerPointsExcForm.find('#hidden_grab_partner_uuid').val();
				if(!($('#points-exc--miles-terms-and-conditions').prop('checked'))) {
					$(".radioErrMsg").removeClass("showclass");
					$(".radioErrMsg").addClass("hideclass");
					$(".error-validation").removeClass("showclass");
          			$(".error-validation").addClass("hideclass");
					$(".termsAndCondition").addClass("showclass");
					$(".termsAndCondition").removeClass("hideclass");
		
				} else if(enrichInptsPts==""|| grabCalPts=="") {
					$(".error-validation").removeClass("hideclass");
					$(".error-validation").addClass("showclass");
					$(".rangeerror").removeClass("hideclass");
					$(".rangeerror").addClass("showclass");
				} else {
					let sucCode:any;
					_self.bookingformcommon.preloader();
					let max_points = $(".partner-crad-exchange.active input:hidden[class='max_count_class']").val();
					let cookieAccessToken = _self.getCookie("sapphire");
				    var decodedToken = parseJwt(cookieAccessToken);
					let data = {
						"partnerUserID": partnerUuid,
						"name": "grabPoints",
						"grab_points": grabCalPts,
						'enrich_points':enrichInptsPts,
						'partnerId':'Grab',
					  'max_points':max_points,
						'loyaltyToken':	decodedToken.extension_loyaltyToken,
						'action':'validateOTP',
					'code':validateCode
					}
					adobeDataLayer.push('click', {
						'pageName': '',
						'pageType': 'Enrich Redemption Page - Catalogue Item PDP ',
						'clickName': 'click:btn-click:catalogue-redemption-submit',
						'componentType': 'btn',
						'componentName': 'Redemption Submit Button',
						'componentID': '',
						'attributes': [
							{
								'key': 'catalogue-redemption-submit',
								'value': max_points+':'+grabCalPts
							}
						] 
					});
					$.ajax({
						type: 'POST',
						url: '/bin/services/new/enrichMilesToGrabPointsConverterLcp',
						data: data,
						success: function(data: any) {

							let json:any = null;
							if (typeof data === 'string') {
								json = JSON.parse(data);
							}	else {
								json = data;
							}
						_self.bookingformcommon.preloaderClose();
						sucCode=json.succCode;
						if (sucCode == "OK") {	
							console.log("sucess");
							//let navMilesEl = _self.$memberHeader.find('.member-nav--miles-info .miles-value');
							let navMilesVal = json.currentBalance;
							$(".miles-value").text(numeral(navMilesVal).format('0,0'));
							document.cookie = "milesCount=" + navMilesVal + ";path=/";
							$(".points-exchange-form-confirm").removeClass("showclass");
							$(".points-exchange-form-confirm").addClass("hideclass");
							$(".points-exchange-form-display").removeClass("showclass");
							$(".points-exchange-form-display").addClass("hideclass");
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".rangeerrorBalCheck").removeClass("showclass");
							$(".rangeerrorBalCheck").addClass("hideclass");
							$("#grab_succ").removeClass("hideclass");
							$("#grab_succ").addClass("showclass");
							$('#grab_failure').removeClass('showclass');
							$('#grab_failure').addClass('hideclass');
							$('#enrichMiles').html(enrichInptsPts);
							$('#grabCalPts').html(grabCalPts);
						}else if(sucCode=="OTPERROR")
						{
							$(".btn-points--check--confirm--submit").removeClass("disablee");
							$(".points-exchange-form-confirm").removeClass("hideclass");
							$(".points-exchange-form-confirm").addClass("showclass");
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".securityvalidCodeerror").removeClass("hideclass");//SHOW
							$(".securityvalidCodeerror").addClass("showclass");//SHOW
							$(".securityCodeerror").removeClass("showclass");
							$(".securityCodeerror").addClass("hideclass");
						}else{
							$(".points-exchange-form-confirm").removeClass("showclass");
							$(".points-exchange-form-confirm").addClass("hideclass");
							$(".points-exchange-form-display").removeClass("showclass");
							$(".points-exchange-form-display").addClass("hideclass");
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".rangeerrorBalCheck").removeClass("showclass");
							$(".rangeerrorBalCheck").addClass("hideclass");
							$("#grab_succ").removeClass("showclass");
							$("#grab_succ").addClass("hideclass");
							$('#grab_failure').removeClass('hideclass');
							$('#grab_failure').addClass('showclass');
						}
							
						}, error: function(error: any) {
							_self.bookingformcommon.preloaderClose();
							defer.reject(error);
						}
					});
				}

				}
				else{
				var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'partner_code': partner_code,
					'action':'validateOTP',
					'code':validateCode,
					'cap_count':cap_count,
					'enrich_points':enrichMiles,
					'binfinite_points':inputPoints,
					'cardNumber':cardInputNumber,
					'partnerId':partner_id,
					'max_points':max_points
				};
				adobeDataLayer.push('click', {
					'pageName': '',
					'pageType': 'Enrich Redemption Page - Catalogue Item PDP ',
					'clickName': 'click:btn-click:catalogue-redemption-submit',
					'componentType': 'btn',
					'componentName': 'Redemption Submit Button',
					'componentID': '',
					'attributes': [
						{
							'key': 'catalogue-redemption-submit',
							'value': max_points+':'+enrichMiles
						}
					] 
				});
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/binfinitevalidateCartLCP',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
							if (typeof data === 'string') {
								json = JSON.parse(data);
							}	else {
								json = data;
							}
						_self.bookingformcommon.preloaderClose();
						succCode=json.succCode;
						
						if (succCode == "OK") {
							console.log("sucess");
							//let navMilesEl = _self.$memberHeader.find('.member-nav--miles-info .miles-value');
							let navMilesVal = json.currentBalance;
							$(".miles-value").text(numeral(navMilesVal).format('0,0'));
							document.cookie = "milesCount=" + navMilesVal + ";path=/";
							$(".error-validation").removeClass("showclass");
				$(".error-validation").addClass("hideclass");
				$(".securityCodeerror").removeClass("showclass");
				$(".securityCodeerror").addClass("hideclass");
			$(".disply-partner-cards").removeClass("showclass");
            $(".disply-partner-cards").addClass("hideclass");
            // $(".points-exchange-form-display").removeClass("showclass");
			// $(".points-exchange-form-display").addClass("hideclass");
			$( "h2" ).hide();
			$(".points-exchange-form-confirm").removeClass("showclass");
			$(".points-exchange-form-confirm").addClass("hideclass");
			$(".confirm--button--form--field").removeClass("showclass");
			$(".confirm--button--form--field").addClass("hideclass");
			$(".confirm--mail--security--check").removeClass("showclass");
			$(".confirm--mail--security--check").addClass("hideclass");
			if(json.partnerCode!=null && json.partnerCode=="Binfinite")
			{
				$("#binfinite_succ").removeClass("hideclass");//SHOW
				$("#binfinite_succ").addClass("showclass");//SHOW
				$("#sunway_succ").removeClass("showclass");//SHOW
				$("#sunway_succ").addClass("hideclass");//SHOW
				$("#biAcctID").text(json.resp_BI_accountID);
				$("#bi-points").text(json.resp_BI_points);
				$("#bonuslink_succ").removeClass("showclass");//SHOW
				$("#bonuslink_succ").addClass("hideclass");//SHOW
			}else if(json.partnerCode!=null && json.partnerCode=="Sunwaypals"){
				$("#sunway_succ").removeClass("hideclass");//SHOW
				$("#sunway_succ").addClass("showclass");//SHOW
				$("#binfinite_succ").removeClass("showclass");//SHOW
				$("#binfinite_succ").addClass("hideclass");//SHOW
				$("#sunwayAcctID").text(json.resp_BI_accountID);
				$("#sunway-points").text(json.resp_BI_points);
				$("#bonuslink_succ").removeClass("showclass");//SHOW
				$("#bonuslink_succ").addClass("hideclass");//SHOW
			}else if(json.partnerCode!=null && json.partnerCode=="BonusLink"){
				$("#bonuslink_succ").removeClass("hideclass");//SHOW
				$("#bonuslink_succ").addClass("showclass");//SHOW
				$("#binfinite_succ").removeClass("showclass");//SHOW
				$("#binfinite_succ").addClass("hideclass");//SHOW
				$("#sunway_succ").removeClass("showclass");//SHOW
				$("#sunway_succ").addClass("hideclass");//SHOW
				$("#bonuslinkAcctID").text(json.resp_BI_accountID);
				$("#bonuslink-points").text(json.resp_BI_points);
			}
			
			$(".points-exchange-form-failure--div").removeClass("showclass");
			$(".points-exchange-form-failure--div").addClass("hideclass");
			$(".securityvalidCodeerror").removeClass("showclass");
			$(".securityvalidCodeerror").addClass("hideclass");
						}else if(succCode=="OTPERROR")
						{
							$(".btn-points--check--confirm--submit").removeClass("disablee");
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".securityvalidCodeerror").removeClass("hideclass");//SHOW
							$(".securityvalidCodeerror").addClass("showclass");//SHOW
							$(".securityCodeerror").removeClass("showclass");
							$(".securityCodeerror").addClass("hideclass");
						}/*else if(succCode=="CRANEGE"){
							
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".disply-partner-cards").removeClass("showclass");
            				$(".disply-partner-cards").addClass("hideclass");
           	 				$(".points-exchange-form-display").removeClass("showclass");
							$(".points-exchange-form-display").addClass("hideclass");
							$(".points-exchange-form-confirm").removeClass("showclass");
							$(".points-exchange-form-confirm").addClass("hideclass");
							$(".confirm--mail--security--check").removeClass("showclass");
							$(".confirm--mail--security--check").addClass("hideclass");
							$(".securityvalidCodeerror").removeClass("showclass");
							$(".securityvalidCodeerror").addClass("hideclass");
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("hideclass");//SHOW
							$(".points-exchange-form-failure--div").addClass("showclass");//SHOW
							$(".crane-err-msg").removeClass("hideclass");//SHOW
							$(".crane-err-msg").addClass("showclass");//SHOW
							$(".general-err-msg").removeClass("showclass");
							$(".general-err-msg").addClass("hideclass");
							$(".bInfinite-err-msg").removeClass("showclass");
							$(".bInfinite-err-msg").addClass("hideclass");
						}else if(succCode=="BIGE"){
							
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".disply-partner-cards").removeClass("showclass");
            				$(".disply-partner-cards").addClass("hideclass");
           	 				$(".points-exchange-form-display").removeClass("showclass");
							$(".points-exchange-form-display").addClass("hideclass");
							$(".points-exchange-form-confirm").removeClass("showclass");
							$(".points-exchange-form-confirm").addClass("hideclass");
							$(".confirm--mail--security--check").removeClass("showclass");
							$(".confirm--mail--security--check").addClass("hideclass");
							$(".securityvalidCodeerror").removeClass("showclass");
							$(".securityvalidCodeerror").addClass("hideclass");
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("hideclass");//SHOW
							$(".points-exchange-form-failure--div").addClass("showclass");//SHOW
							$(".bInfinite-err-msg").removeClass("hideclass");//SHOW
							$(".bInfinite-err-msg").addClass("showclass");//SHOW
							$(".general-err-msg").removeClass("showclass");
							$(".general-err-msg").addClass("hideclass");
							$(".crane-err-msg").removeClass("showclass");
							$(".crane-err-msg").addClass("hideclass");
						}*/
						else{
							
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".disply-partner-cards").removeClass("showclass");
            				$(".disply-partner-cards").addClass("hideclass");
           	 				// $(".points-exchange-form-display").removeClass("showclass");
							// $(".points-exchange-form-display").addClass("hideclass");
							$(".points-exchange-form-confirm").removeClass("showclass");
							$(".points-exchange-form-confirm").addClass("hideclass");
							$(".confirm--mail--security--check").removeClass("showclass");
							$(".confirm--mail--security--check").addClass("hideclass");
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("hideclass");//SHOW
							$(".points-exchange-form-failure--div").addClass("showclass");//SHOW
							$(".general-err-msg").removeClass("hideclass");//SHOW
							$(".general-err-msg").addClass("showclass");//SHOW
							$("#error_code").text(json.err_status_code);
							$("#error_msg").text(json.err_message);
							$(".accounterror").removeClass("showclass");
							$(".accounterror").addClass("hideclass");
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".cardStatusError").removeClass("showclass");
							$(".cardStatusError").addClass("hideclass");
							$(".cardnumberformatErrMsg").removeClass("showclass");
							$(".cardnumberformatErrMsg").addClass("hideclass");
							$(".mailOTPError").removeClass("showclass");
							$(".mailOTPError").addClass("hideclass");
							$(".securityCodeerror").removeClass("showclass");
							$(".securityCodeerror").addClass("hideclass");
							$(".securityvalidCodeerror").removeClass("showclass");
							$(".securityvalidCodeerror").addClass("hideclass");
						}
						defer.resolve(json);			
					}, error: function(error: any) {
						
						_self.bookingformcommon.preloaderClose();
						defer.reject(error);
					}
				});
			}
			}
		});
		$(".btn-points--check--req-again").click(function() {
			$(".btn-points--check--req-again").addClass("disablee");
			_self.partnerPointsExcForm.find('#security-code--check').val("");
			$(".btn-points--check--confirm--submit").removeClass("disablee");
			$(".error-validation").removeClass("showclass");
			$(".error-validation").addClass("hideclass");
			$(".securityCodeerror").removeClass("showclass");
			$(".securityCodeerror").addClass("hideclass");
			$(".securityvalidCodeerror").removeClass("showclass");
			$(".securityvalidCodeerror").addClass("hideclass");
			let cookieAccessToken = _self.getCookie("sapphire");
				var decodedToken = parseJwt(cookieAccessToken);
				let cap_count  = $(".partner-crad-exchange.active input:hidden[class='cap_period_class']").val();
				let partner_code  = $(".partner-crad-exchange.active input:hidden[class='partner_code_class']").val();
				let succCode:any;
				var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'partner_code': partner_code,
					'action':'generateOTP',
					'channel':'LCP'
				};
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/binfinitevalidateCartLCP',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
							if (typeof data === 'string') {
								json = JSON.parse(data);
							}	else {
								json = data;
							}
						_self.bookingformcommon.preloaderClose();
						succCode=json.succCode;
						if (succCode == "OK") {	
							$(".btn-points--check--confirm--submit").removeClass("disablee");
						}
						else
						{
							
						}
						defer.resolve(json);			
					}, error: function(error: any) {
						
						_self.bookingformcommon.preloaderClose();
						defer.reject(error);
					}
				});
			let timeleft = 60;
			let downloadTimer = setInterval(function(){
			$("#timerdisp").removeClass("hideclass");
			$("#timerdisp").addClass("showclass");
			let seconds = _self.checkTime(timeleft);
			  document.getElementById("timerdisp").innerHTML = " ("+seconds+")";
			  //$(".btn-points--check--req-again").append(seconds);
  			timeleft -= 1;
  			if(timeleft<= 0){
				clearInterval(downloadTimer);
				$("#timerdisp").removeClass("showclass");
				$("#timerdisp").addClass("hideclass");
				$("#timerdisp").empty();
				   $(".btn-points--check--req-again").removeClass("disablee");
				   $(".btn-points--check--req-again").remove(seconds);
  			}
		   }, 1000);
		});
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};
	}
	checkTime(i:any)
	{
		if (i < 10) {
			i = "0" + i;
		  }
		  return i;
	}
	
	rangeslider(): any {
		// Select all range inputs, watch for change
		$("input[type='range']").change(function() {
			var el, newPoint, newPlace, offset;
			// Cache this for efficiency
			el = $(this);
			
			// Measure width of range input
			var width = el.width();
			
			// Figure out placement percentage between left and right of input
			newPoint = (el.val() - el.attr("min")) / (el.attr("max") - el.attr("min"));
			
			offset = -1;
		
			// Prevent bubble from going beyond left or right (unsupported browsers)
			if (newPoint < 0) { newPlace = 0; }
			else if (newPoint > 1) { newPlace = width; }
			else { newPlace = width * newPoint + offset; offset -= newPoint; }
			
			// Move bubble
			el
			.next("output")
			.css({
				left: newPlace,
				marginLeft: offset + "%"
			})
			//  .text(el.val());
			})
			// Fake a change to position bubble at page load
			$("input[type='range']").trigger('change');
	}
	termsandConditionsPanel() {
		$('#binfinitepoints-exchange-miles-form .btn-terms-conditions').click(function(){
			$('#binfinitepoints-exchange-miles-form #binfinte_partner_details').collapse('hide');
		});
		$('#binfinitepoints-exchange-miles-form .btn-partner-details').click(function(){
			$('#binfinitepoints-exchange-miles-form #binfinte_terms').collapse('hide');
		});
		$('#binfinitepoints-exchange-miles-form .sunway-btn-terms-conditions').click(function(){
			$('#binfinitepoints-exchange-miles-form #sunway_partner_details').collapse('hide');
		});
		$('#binfinitepoints-exchange-miles-form .sunway-btn-partner-details').click(function(){
			$('#binfinitepoints-exchange-miles-form #sunway_terms').collapse('hide');
		});
	}
	parseJwt (token:any) {
		var base64Url = token.split('.')[1];
		var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	
		return JSON.parse(base64);
	}
	redirectToCardSelectionScreen(_self: any): any {
		window.location.href = location.hostname + 'my/en/enrich-portal/home/redemption/catalogue-lcp.html';
		_self.bookingformcommon.preloaderClose();
	}
	processGrab(_self: any): any {
		_self.bookingformcommon.preloader();
		try {
			GrabID.handleAuthorizationCodeFlowResponse();
			_self.grabIdClient.makeTokenRequest()
			.then(() => {
				let tokenResult = GrabID.getResult();
				if(tokenResult.accessToken != 'undefined' && tokenResult.accessToken != undefined && tokenResult.accessToken != null) {
					let decodedToken = _self.parseJwt(tokenResult.accessToken);
					$('#hidden_grab_partner_uuid').val(decodedToken.sub);
				} else {
					_self.redirectToCardSelectionScreen(_self);
				}
			});
		} catch(e) {
			let error = JSON.parse(e.message);
			console.log(error);
			_self.redirectToCardSelectionScreen(_self);
		}
	}
	checkForUrlParams(): any {
		const urlParams = new URLSearchParams(window.location.search);
		const state = urlParams.get('state');
		const code = urlParams.get('code');
		if(window.location.search != '' && state !== null && code !== null) {
			return true;
		}
		return false;
	}
	initGrabAuthentication(): any {
		let _self = this;
		let openIdUrl = GrabID.GrabPartnerUrls.STAGING;
		if (window.location.hostname !== 'localhost' && window.location.hostname.indexOf('uat') == -1) {
			openIdUrl = GrabID.GrabPartnerUrls.PRODUCTION;
		}
		let grabClientId = $(".partner-crad-exchange input:hidden[class='grab_client_id_class']").val();
		let requestUri = $(".partner-crad-exchange input:hidden[class='grab_request_uri_class']").val();
		let appConfig = {
			clientId: grabClientId,
			redirectUri: requestUri,
			scope: 'rewards.events_api',
			acrValues: {
				service: 'PASSENGER',
				consentContext: {
					countryCode: 'MY'
				}
			}
		}
		this.grabIdClient = new GrabID(openIdUrl, appConfig);
	}
}
let scope:Element = document.querySelector('#binfinitepoints-exchange-miles-form');

if (scope) {
	try {
	let membergrv = new memberPointsExchange();	
	membergrv.initSelectCard();
	membergrv.rangeslider();
	membergrv.initSubmitNextForm();
	membergrv.initSubmitConfirmForm();
	membergrv.initSubmitSuucssForm();
	membergrv.termsandConditionsPanel();
	var adobeDataLayer = new adobeDataLayerWrapper();
	adobeDataLayer.push('pageLoaded', {
		'pageName': '',
		'pageType': 'Enrich Redemption Page - Catalogue Item PDP',
		'attributes': []
	});
	} catch(e) {console.error(e);}
}